export default {
  title: 'Køb e-gavekort',
  subtitle:
    'Sig det med et gavekort fra {{companyName}}. Perfekt til fødselsdage, som tak eller bare fordi – kan indløses fleksibelt til mad og drikke.',
  header: {
    title: 'Gavekort',
    subtitle: 'Skænk glæde',
  },
  buttons: {
    buy_now: 'Køb nu',
  },
};
